// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixField } from './PFixField.js'

var PFixPublicKeyField = function (fieldId, buffer)
{
    this.Value = null;
    PFixField.call(this, fieldId, buffer)
}

PFixPublicKeyField.prototype = Object.create(PFixField.prototype);

PFixPublicKeyField.prototype.ReadValue = function (buffer)
{
    let certificateSize = buffer.ReadShort();
    var certificateBytes = buffer.ReadBuffer(certificateSize).ReadAllBytes();
    this.Value = certificateBytes;
};

PFixPublicKeyField.prototype.Write = function (buffer)
{
    buffer.WriteShort(this.FieldId);

    if (this.Value == null)
        return;

    buffer.WriteShort(this.Value.length);
    buffer.WriteBuffer(certBytes);
};

export { PFixPublicKeyField }